import Colors from '@utils/Colors.js'

// TopNav (NavBar) and SideNav take their sizes and colours from here. Change a value here instead of in a component.

export const topNavSizes = {
    // The page starts below the bar
    height: 60
}

export const sideNavSizes = {
    // The rail, the page starts at its right
    width: 64,
    // Over the page while hovered or focused, the page doesn't move
    expandedWidth: 232,
    padding: 8,
    rowHeight: 44,
    // The icon column: the width of the rail without its padding, so the icons stay in place when it expands
    iconColumn: 48,
    iconSize: 22,
    fontSize: 14,
    subTitleFontSize: 12,
    gap: 4,
    radius: 8,
    // The bar at the left of the active row
    indicatorWidth: 3,
    logoSize: 32,
    avatarSize: 32,
    // Wait a moment before collapsing, so moving the mouse along the edge doesn't make it flicker
    collapseDelay: 150,
    transition: '.18s ease'
}

export const sideNavColors = {
    background: Colors.backgroundDark,
    text: 'rgba(255, 255, 255, 0.62)',
    textActive: Colors.white,
    hover: 'rgba(255, 255, 255, 0.06)',
    active: 'rgba(255, 255, 255, 0.12)',
    divider: 'rgba(255, 255, 255, 0.08)',
    avatar: 'rgba(255, 255, 255, 0.14)',
    // While expanded over the page
    shadow: '4px 0 24px rgba(0, 0, 0, 0.25)'
}

/**
 * Colour of the line under the active item of the top bar and the bar next to the active row of the side nav: the
 * colour of the branding, grey while the branding is loading (undefined).
 */
export function navActiveColor(branding?: {color?: string} | null): string {
    if (branding === undefined) {
        return Colors.grey20
    }

    return branding?.color || Colors.brandColor
}
